export var MOCK_HEADER_DATA = {
  locale: 'en-US',
  label: 'Header',
  productNavigation: {
    title: 'What is Miro',
    groups: [{
      title: 'Product',
      items: [{
        title: 'Product Overview',
        path: '/product-overview/',
        description: '',
        image: null
      }, {
        title: 'Visual Project Management',
        path: '/how-project-managers-use-miro/',
        description: '',
        image: null
      }, {
        title: 'Diagramming & Process Mapping',
        path: '/diagramming/',
        description: '',
        image: null
      }, {
        title: 'Product Development Workflows',
        path: '/product-development/',
        description: '',
        image: null
      }, {
        title: 'Content & Data Visualization',
        path: '/team-workspace/',
        description: '',
        image: null
      }, {
        title: 'Workshops & Async Collaboration',
        path: '/workshops-async-collaboration/',
        description: '',
        image: null
      }, {
        title: 'Miro Assist',
        path: '/ai/',
        description: '',
        image: null
      }, {
        title: 'Apps & Integrations',
        path: '/integrations/',
        description: '',
        image: null
      }, {
        title: 'Developer Platform',
        path: 'https://developers.miro.com/',
        description: '',
        image: null
      }],
      viewAllLink: null
    }]
  },
  solutionsNavigation: {
    title: 'Solutions',
    groups: [{
      title: 'By Team',
      items: [{
        title: 'Product Management',
        path: '/how-product-teams-use-miro/',
        description: '',
        image: null
      }, {
        title: 'Engineering',
        path: '/how-development-teams-use-miro/',
        description: '',
        image: null
      }, {
        title: 'IT Teams',
        path: '/how-it-teams-use-miro/',
        description: '',
        image: null
      }, {
        title: 'UX & Design',
        path: '/how-ux-teams-use-miro/',
        description: '',
        image: null
      }, {
        title: 'Consultants & Agencies',
        path: '/consultants-agencies/',
        description: '',
        image: null
      }, {
        title: 'Marketing',
        path: '/how-marketing-teams-use-miro/',
        description: '',
        image: null
      }, {
        title: 'Sales',
        path: '/how-sales-teams-use-miro/',
        description: '',
        image: null
      }],
      viewAllLink: null
    }, {
      title: 'By Use Case',
      items: [{
        title: 'Technical Diagramming',
        path: '/technical-diagramming/',
        description: '',
        image: null
      }, {
        title: 'Whiteboarding',
        path: '/whiteboard/',
        description: '',
        image: null
      }, {
        title: 'Wireframing',
        path: '/wireframe/',
        description: '',
        image: null
      }, {
        title: 'Mind Map',
        path: '/mind-map/',
        description: '',
        image: null
      }, {
        title: 'Retrospectives',
        path: '/agile/retrospective/',
        description: '',
        image: null
      }, {
        title: 'Scaled Product Planning',
        path: '/agile/pi-planning/',
        description: '',
        image: null
      }, {
        title: 'Process Mapping',
        path: '/process-mapping/',
        description: '',
        image: null
      }, {
        title: 'Customer Journey Mapping',
        path: '/customer-journey-map/',
        description: '',
        image: null
      }, {
        title: 'Strategy & Planning',
        path: '/strategic-planning/',
        description: '',
        image: null
      }],
      viewAllLink: null
    }]
  },
  resourcesNavigation: {
    title: 'Resources',
    groups: [{
      title: 'Connect & Learn',
      items: [{
        title: 'Miroverse Templates',
        path: '/miroverse/',
        description: '',
        image: null
      }, {
        title: 'Community ',
        path: 'https://community.miro.com',
        description: '',
        image: null
      }, {
        title: 'Academy',
        path: 'https://academy.miro.com/',
        description: '',
        image: null
      }, {
        title: 'Help Center',
        path: 'https://help.miro.com',
        description: '',
        image: null
      }, {
        title: 'Blog',
        path: '/blog/',
        description: '',
        image: null
      }, {
        title: 'Developer Platform',
        path: 'https://developers.miro.com/',
        description: '',
        image: null
      }],
      viewAllLink: null
    }, {
      title: 'Explore',
      items: [{
        title: 'Templates',
        path: '/templates/',
        description: '',
        image: null
      }, {
        title: 'Customer Journey Mapping Template',
        path: '/templates/customer-journey-map/',
        description: '',
        image: null
      }, {
        title: 'Business Model Canvas Template',
        path: '/templates/business-model-canvas/',
        description: '',
        image: null
      }, {
        title: 'User Story Map Template',
        path: '/templates/user-story-map/',
        description: '',
        image: null
      }, {
        title: 'Product Roadmap Template',
        path: '/templates/product-roadmap/',
        description: '',
        image: null
      }],
      viewAllLink: null
    }]
  },
  enterpriseNavigation: {
    title: 'Enterprise',
    groups: [{
      title: 'Enterprise-grade workspace',
      items: [{
        title: 'Overview',
        path: '/enterprise/',
        description: '',
        image: null
      }, {
        title: 'Trust & Security',
        path: '/security/',
        description: '',
        image: null
      }, {
        title: 'Accessibility',
        path: '/accessibility-statement/',
        description: '',
        image: null
      }, {
        title: 'Customer Stories',
        path: '/customers/',
        description: '',
        image: null
      }],
      viewAllLink: null
    }]
  },
  pricingLink: {
    title: 'Pricing',
    path: '/pricing/',
    description: '',
    image: null
  },
  contactSalesLink: {
    title: 'Contact Sales',
    path: '/contact/sales/',
    description: '',
    image: null
  },
  loginLink: {
    title: 'Login',
    path: '/login/',
    description: '',
    image: null
  },
  signupButton: {
    title: 'Sign up free',
    path: '/signup/',
    description: '',
    image: null
  },
  dashboardButton: {
    title: 'Go to the dashboard',
    path: '/app/',
    description: '',
    image: null
  },
  bottomLinks: [{
    title: 'Contact Sales',
    path: '/contact/sales/',
    description: '',
    image: null
  }],
  whatsNew: {
    title: 'What’s new',
    items: [{
      path: '/miroverse/',
      title: 'New templates',
      description: '800+ creators, 1000+ templates, find everything you need',
      image: {
        src: '//images.ctfassets.net/w6r2i5d8q73s/21VkY7RX1MDBBeiQaY3SQe/b97afb5de86853e0e3ddf5866ec2d2ad/new-templates.png',
        width: 272,
        height: 180,
        name: 'new-templates'
      }
    }, {
      path: '/works-with-slack/',
      title: 'Sign in with Slack ',
      description: 'Connect to Miro by using your Slack',
      image: {
        src: '//images.ctfassets.net/w6r2i5d8q73s/16FGWpDjU3jmVQ20A4kS5P/da1c90a82861e9f72cbca2b022820b9c/Sign-in-with-slack.png',
        width: 272,
        height: 180,
        name: 'Sign-in-with-slack'
      }
    }],
    showAllLink: {
      title: 'See changelog',
      path: '/changelog/',
      description: '',
      image: null
    }
  }
};
var productNavigation = MOCK_HEADER_DATA.productNavigation,
    solutionsNavigation = MOCK_HEADER_DATA.solutionsNavigation,
    resourcesNavigation = MOCK_HEADER_DATA.resourcesNavigation,
    enterpriseNavigation = MOCK_HEADER_DATA.enterpriseNavigation;
export var MOCK_PAGE_PATHS = [productNavigation, solutionsNavigation, resourcesNavigation, enterpriseNavigation].reduce(function (accumulator, item) {
  var _item$groups;

  (_item$groups = item.groups) === null || _item$groups === void 0 ? void 0 : _item$groups.forEach(function (group) {
    group.items.forEach(function (item) {
      accumulator.push(item.path);
    });
  });
  return accumulator;
}, []).sort();